import { CustomerOrganization } from "../../utils/interfaces";
import { CustomerNotesHistorySection } from "./CustomerNotesHistorySection";

interface CustomerDescriptionSectionProps {
  customer: CustomerOrganization;
  onCustomerUpdate?: () => void;
  queriesEnabled?: boolean;
}

export const CustomerDescriptionSection = ({
  customer,
  onCustomerUpdate,
  queriesEnabled = true,
}: CustomerDescriptionSectionProps) => (
  <CustomerNotesHistorySection
    customerOrgId={customer.id}
    language={customer.language || "English"}
    onCustomerUpdate={onCustomerUpdate}
    queriesEnabled={queriesEnabled}
  />
);
